import { HttpErrorResponse } from '@angular/common/http';
import { Email, Office, TechSupport, AccountManager, DefinitionCategory, Faq, FaqCategory } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const fetchContactUsOffices = createAction('[ContactUs] - Fetch Contact us offices');
export const fetchContactUsTechSupport = createAction('[ContactUs] - Fetch Contact us tech support');
export const fetchContactUsAccountManagers = createAction('[ContactUs] - Fetch Contact us account managers');
export const sendContactUsFeedback = createAction('[ContactUs] - Send Contact us feedback', props<{ email: Email }>());
export const resetFeedbackResult = createAction('[ContactUs] - Reset feedback result');
export const getContactUsOfficeSuccess = createAction('[ContactUs] - Get offices success', props<{ offices: Office[] }>());
export const fetchCategoryDefinitions = createAction(
    '[Definitions] - Fetch Category definitions',
    props<{ categoryId: number; categoryTitle: string }>()
);
export const setIsLoading = createAction('[Definitions] - Set is loading');

export const getContactUsTechSupportSuccess = createAction(
    '[ContactUs] - Get tech support success',
    props<{ techSupport: TechSupport | undefined }>()
);

export const getContactUsAccountManagerSuccess = createAction(
    '[ContactUs] - Get account managers success',
    props<{ accountManagers: AccountManager[] }>()
);

export const sendContactUsFeedbackSuccess = createAction('[ContactUs] - Send feedback success');

export const getCategoryDefinitionsSuccess = createAction(
    '[Definitions] - Get Category Definitions success',
    props<{ categoryDefinitions: DefinitionCategory }>()
);

export const sendContactUsFeedbackFailure = createAction('[ContactUs] - Send feedback failure', props<{ error: HttpErrorResponse }>());

export const contactUsDetailsFailure = createAction('[ContactUs] - Get Contact us details failure', props<{ error: HttpErrorResponse }>());

export const getCategoryDefinitionsFailure = createAction(
    '[Definitions] - Get Category Definitions failure',
    props<{ error: HttpErrorResponse }>()
);

export const getDefinitions = createAction('[Definitions] - Get Definitions');

export const getDefinitionsSuccess = createAction(
    '[Definitions] - Get Definitions success',
    props<{ definitions: DefinitionCategory[] }>()
);

export const getDefinitionsFailure = createAction('[Definitions] - Get Definitions failure', props<{ error: HttpErrorResponse }>());

export const getFaqCategories = createAction('[FAQ Categories] - Get Faq Categories');

export const getFaqCategoriesSuccess = createAction(
    '[FAQ Categories] - Get Faq Categories Success',
    props<{ faqCategories: FaqCategory[] }>()
);

export const getFaqCategoriesFailure = createAction('[FAQ Categories] - Get Faq Categories Failure', props<{ error: HttpErrorResponse }>());

export const getFaqCategoriesFaqs = createAction('[FAQ Categories] - Get Faq Categories Faqs');

export const getFaqCategoriesFaqsSuccess = createAction('[FAQ Categories] - Get Faq Categories Faqs Success', props<{ faqs: Faq[] }>());

export const getFaqCategoriesFaqsFailure = createAction(
    '[FAQ Categories] - Get Faq Categories Faqs Failure',
    props<{ error: HttpErrorResponse }>()
);
